import type { BrushDefinition } from "./brushTypes";

export const eraserBrush: BrushDefinition = {
  tool: "eraser",
  label: "Eraser",
  widthMultiplier: 1.3,
  baseOpacity: 1,
  interpolationSpacing: 0.18,
  pressureSensitive: true,
  texture: "eraser",
};
